/*
 * Microsoft Azure Active Directory (MSAL) Configuration for Blitz.ai
 * App registration: SLT-WorkMate AI
 * Application (client) ID: 437e0ec1-9151-438f-9ddb-d86e6e25527d
 * Directory (tenant) ID:   534253fc-dfb6-462f-b5ca-cbe81939f5ee
 */

// Dynamically matches exact Azure Portal redirect URIs for both environments
const getRedirectUri = () => {
  const origin = window.location.origin;
  let uri;
  // Production Azure SPA redirect URI: https://backofficeagent.sltdigitallab.lk/
  if (origin.includes("backofficeagent.sltdigitallab.lk")) {
    uri = origin.endsWith('/') ? origin : `${origin}/`;
  } else {
    // Local dev Azure SPA redirect URI: http://localhost:3000/auth
    uri = `${origin.replace(/\/$/, "")}/auth`;
  }
  console.log("🔒 [MSAL Config] getRedirectUri():", uri);
  return uri;
};

export const msalConfig = {
  auth: {
    clientId: "437e0ec1-9151-438f-9ddb-d86e6e25527d",
    authority: "https://login.microsoftonline.com/534253fc-dfb6-462f-b5ca-cbe81939f5ee",
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: getRedirectUri(),
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

// Standard Microsoft identity scopes for sign-in.
// Do NOT add the Application ID URI (api://437e0ec1-...) here unless a
// custom backend API scope is explicitly defined in the app registration.
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
};